/**
 * @description 品目模板相关接口
 */
import request from '@/utils/request'
import { addQueryToUrl } from '@/utils/utils'

const purchaseApi = process.env.VUE_APP_PURCHASE_API

// 获取模板列表
export function getMaterialTemplatePageApi(params) {
  return request({
    url: purchaseApi + '/workbench/item-templates/page',
    method: 'get',
    params
  })
}

// 删除模板
export function removeMaterialTemplateApi(templateId) {
  return request({
    url: purchaseApi + `/workbench/item-templates/${templateId}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 设置为默认模板
export function setDefaultMaterialTemplateApi(templateId) {
  return request({
    url: purchaseApi + `/workbench/item-templates/${templateId}/set-default`,
    method: 'put',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 禁用模板
export function disableMaterialTemplateApi(templateId) {
  return request({
    url: purchaseApi + `/workbench/item-templates/${templateId}/disable`,
    method: 'put',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 启用模板
export function enableMaterialTemplateApi(templateId) {
  return request({
    url: purchaseApi + `/workbench/item-templates/${templateId}/enable`,
    method: 'put',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 保存模板
export function saveMaterialTemplateApi(data) {
  return request({
    url: purchaseApi + '/workbench/item-templates',
    method: 'post',
    data
  })
}

// 保存模板（更新品目模板）
export function saveUpdateMaterialTemplateApi(data) {
  const { templateId } = data
  return request({
    url: purchaseApi + `/workbench/item-templates/${templateId}`,
    method: 'put',
    data
  })
}

// 发布模板
export function publishMaterialTemplateApi(data) {
  return request({
    url: purchaseApi + '/workbench/item-templates/release',
    method: 'post',
    data
  })
}

// 发布模板（更新并发布品目模板）
export function publishUpdateMaterialTemplateApi(data) {
  const { templateId } = data
  return request({
    url: purchaseApi + `/workbench/item-templates/${templateId}/release`,
    method: 'put',
    data
  })
}

// 查询模板详情
export function getMaterialTemplateApi(templateId) {
  return request({
    url: purchaseApi + `/workbench/item-templates/${templateId}/detail`,
    method: 'get'
  })
}

// 获取首选的模板（系统初始化获取默认）
export function getDefaultMaterialTemplateApi(params) {
  return request({
    url: purchaseApi + '/workbench/item-templates/starter/detail',
    method: 'get',
    params
  })
}

// 下载品目模板
export function downloadMaterialTemplateApi(orderId) {
  window.open(
    addQueryToUrl(
      `${purchaseApi}/workbench/purchaser/inquiry-orders/export/${orderId}/materiel-template`
    ),
    '_blank'
  )
}
